import * as React from 'react';
import { IMyHomeLayoutProps } from '../../types/myHomeForm';
import * as styles from '../shared_my_home_styles.css';
import { Label } from '../../../common/packages/Label';
import { FilterWithButtonGroup } from '../../../common/packages/FilterWithButtonGroup';
import cn from 'clsx';
import { AddressInput } from '../../../common/packages/AddressInput';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';
import { SectionSelector } from '../../../common/packages/SectionSelector';
import { RoomsCountSelector } from '../../../common/packages/RoomsCountSelector';
import { AreaInput } from '../../../common/packages/AreaInput';

export const NewbuildingComponent: React.FC<IMyHomeLayoutProps> = props => {
  return (
    <div className={styles['container']}>
      <form className={styles['form-content']} onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <div className={styles['form-content-item']}>
          <Label label="Тип недвижимости" />
          <FilterWithButtonGroup {...props.estimationTargetProps} testId="my_home_estimation_target_control" />
        </div>

        <div className={styles['form-content-item']}>
          <div>
            <Label label="Адрес" />
            <AddressInput className={styles['form-content-fixed-height']} {...props.addressProps} />
          </div>
        </div>

        <div className={cn(styles['form-content-item'], styles['form-content-newbuilding-item'])}>
          <div className={styles['newbuilding-name']}>
            <IconMapPin16 color="gray_icons_100" />
            <ArticleParagraph2 color="gray60_100">ЖК {props.newbuildingSectionProps.newbuildingName}</ArticleParagraph2>
          </div>

          {props.newbuildingSectionProps.selectedSection && (
            <div className={cn(styles['form-content-item'], cn(styles['form-content-section-item']))}>
              <div>
                <Label label="Корпус" />
                <SectionSelector {...props.newbuildingSectionProps} />
              </div>
            </div>
          )}
        </div>

        <div className={cn(styles['form-content-item'], styles['form-content-flat-items'])}>
          <div>
            <Label label="Количество комнат" />
            <RoomsCountSelector className={styles['form-content-fixed-height']} {...props.roomsCountSelectorProps} />
          </div>

          <div className={styles['form-content-area-item']}>
            <Label label="Площадь" />
            <AreaInput {...props.areaProps} />
          </div>
        </div>
      </form>
    </div>
  );
};
